var React = require('react');

function SelectArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeMiterlimit":"10","d":"M9.25 1L5.12 5.32 1 1"}));
}

SelectArrow.defaultProps = {"fill":"none","viewBox":"0 0 10 7"};

module.exports = SelectArrow;

SelectArrow.default = SelectArrow;
